export default __webpack_public_path__ + "static/winter11-325f1ff37d87bf95f04f9583bed6246e.webp";